import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Download, FileText } from "lucide-react";
import { ownerApi, downloadReportExcel, downloadReportPdf } from "@/lib/api";
import { money } from "@/lib/format";
import { Spinner } from "@/components/common/States";
import { cn } from "@/lib/utils";

const PERIODS = ["week", "month", "quarter", "year"];

export default function OwnerReports() {
  const [period, setPeriod] = useState("month");
  const query = useQuery({ queryKey: ["ownerReports", period], queryFn: () => ownerApi.getReports(period) });
  const r = query.data;

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex gap-2">
          {PERIODS.map((p) => (
            <button key={p} onClick={() => setPeriod(p)} className={cn("rounded-full px-4 py-1.5 text-xs font-semibold capitalize", period === p ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground")}>{p}</button>
          ))}
        </div>
        <div className="flex gap-2">
          <button onClick={() => downloadReportExcel(period)} className="inline-flex items-center gap-1 rounded-full border border-border px-4 py-1.5 text-xs font-semibold"><Download className="h-3.5 w-3.5" /> Excel</button>
          <button onClick={() => downloadReportPdf(period)} className="inline-flex items-center gap-1 rounded-full border border-border px-4 py-1.5 text-xs font-semibold"><FileText className="h-3.5 w-3.5" /> PDF</button>
        </div>
      </div>

      {query.isPending ? <Spinner /> : r ? (
        <>
          <div className="grid gap-3 sm:grid-cols-4">
            {[["Revenue", money(r.revenue)], ["Orders", r.orders_count], ["Avg order", money(r.avg_order_value)], ["New customers", r.new_customers]].map(([l, v]) => (
              <div key={l} className="rounded-2xl border border-border bg-card p-4"><p className="text-xs text-muted-foreground">{l}</p><p className="font-display text-xl font-bold">{v}</p></div>
            ))}
          </div>
          <div className="grid gap-6 lg:grid-cols-2">
            <div>
              <h3 className="mb-2 font-display text-sm font-bold">Revenue by category</h3>
              <div className="space-y-2">
                {r.revenue_by_category.map((c) => {
                  const pct = r.revenue ? Math.round((c.revenue / r.revenue) * 100) : 0;
                  return (
                    <div key={c.category}>
                      <div className="flex justify-between text-sm"><span>{c.category}</span><span className="text-muted-foreground">{money(c.revenue)}</span></div>
                      <div className="mt-1 h-2 rounded-full bg-secondary"><div className="h-2 rounded-full bg-primary" style={{ width: `${pct}%` }} /></div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div>
              <h3 className="mb-2 font-display text-sm font-bold">Best services</h3>
              <div className="space-y-1.5">
                {r.best_services.slice(0, 8).map((s) => (
                  <div key={s.service_id} className="flex justify-between rounded-lg bg-secondary px-3 py-2 text-sm"><span className="truncate">{s.name}</span><span className="text-muted-foreground">{s.qty} · {money(s.revenue)}</span></div>
                ))}
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}
